import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import auth from '@/common/auth/auth';

export default new ColumnSet({
    id: 'organizations-list',
    store,
    version: 4,
    defaultColumns: [
        {
            name: 'name',
            type: 'link',
            to: ({fields}) => ({
                name: 'organization-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['update-organization'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sortable: true,
            sticky: true,
        },
        {
            name: 'id',
            style: {truncate: true},
            sortable: true,
        },
        {
            name: 'address',
        },
        {
            name: 'city',
        },
        {
            name: 'postalCode',
        },
        {
            name: 'country',
        },
    ],
    otherColumns: [
        {
            value: fields => fields.phoneNumbers.map(phone => phone.value),
            name: 'phoneNumbers',
        },
        {
            value: fields => fields.emails.map(email => email.value),
            name: 'emails',
        },
        {
            name: 'taxDescriptor',
        },
        {
            name: 'invoiceTimeZone',
        },
        {
            name: 'isPrimary',
            value: fields => (fields.isPrimary ? 'Yes' : 'No'),
        },
    ],
});
